import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/swiper-bundle.css'; // Importar los estilos de Swiper



const Galeria = () => {
    // Array de imágenes para alimentar el Swiper
    const images = [
        'assets/images/Certificados/1-1.png',
        'assets/images/Certificados/2.png',
        'assets/images/Certificados/3-2.png',
        'assets/images/Certificados/4-2.png',
        'assets/images/Certificados/5-2.png',
        'assets/images/Certificados/6.png',
        'assets/images/Certificados/7.png',
        'assets/images/Certificados/8-2.png',
        'assets/images/Certificados/9-3.png',
        'assets/images/Certificados/10-2.png',
        'assets/images/Certificados/11.png',
        'assets/images/Certificados/11-2.jpg',
        'assets/images/Certificados/12.jpg',
        'assets/images/Certificados/13-1.jpg',
        'assets/images/Certificados/13-2.jpg',
        'assets/images/Certificados/Higiene.jpg',
        'assets/images/Certificados/Nom.jpg',
    ];
    // Estilos en línea para el componente
    const swiperStyles = {
        container: {
            width: '50%',
            height: '100%',
        },
        slide: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        },
        img: {
            maxWidth: '45%',
            height: 'auto',
        },
    };

    return (
        <section id="galeria" style={{ padding: '80px 0', position: 'relative', marginBottom: '20px' }}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-8 offset-sm-2">
                        <div className="section-title text-center" style={{ marginBottom: '50px' }}>
                            <h2>Certificaciones</h2>
                        </div>
                    </div>
                </div>
                <div className="row" >
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        // spaceBetween={1}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                        style={swiperStyles.container}
                    >
                        {images.map((img, i) => (
                            <SwiperSlide key={i} style={swiperStyles.slide}>
                                <img src={`/${img}`} alt={`screenshot-${i}`} style={swiperStyles.img} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Galeria;